import { CustomDueDatePicker } from 'components/atoms/due-date-picker';
import { withAccess } from 'hooks/rbac/withAccess';

export const RbacCustomDueDatePicker = withAccess(CustomDueDatePicker);
